import { createContext, useContext, useState, useEffect } from "react";
import { isAuthenticated, getUser, logout as authLogout } from "../api/auth";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [isAuth, setIsAuth] = useState(false);
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const reloadPage = () => {
    window.location.reload();
  };

  // Проверка авторизации при загрузке приложения
  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = () => {
    const authenticated = isAuthenticated();
    setIsAuth(authenticated);

    if (authenticated) {
      const u = getUser();
      setUser(u);
    }

    setIsLoading(false);
  };

  const handleLoginSuccess = (response) => {
    setIsAuth(true);
    setUser(response.user);
    reloadPage();
  };

  const logout = () => {
    authLogout();
    setIsAuth(false);
    setUser(null);
    reloadPage();
  };

  const value = {
    isAuth,
    user,
    isLoading,
    handleLoginSuccess,
    logout,
    checkAuth,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};